import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { UserContext } from "../../../../Context/UserContextAPI";
const baseUrl = process.env.REACT_APP_API_BASE_URL;
export default function KuwaitVisaPrint() {
  const { userId } = useParams();
  const { settingsData } = useContext(UserContext);
  const [userDetail, setUserDetail] = useState();
  const [user, setUser] = useState();

  const getUserDetail = async () => {
    try {
      const response = await axios.get(
        `${baseUrl}/user-details/test/${userId}`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${localStorage?.getItem("jwtToken")}`,
          },
        },
      );
      setUserDetail(response?.data?.data?.userDetail);
      setUser(response?.data?.data?.userDetail?.user);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getUserDetail();
  }, []);

  // useEffect(() => {
  //   setTimeout(() => {
  //     window.print();
  //   }, 2000);
  // }, []);

  const genderDefineHandler = (gender) => {
    if (gender?.toLowerCase() === "male") {
      return "He";
    } else if (gender?.toLowerCase() === "female") {
      return "She";
    } else {
      return "He/She";
    }
  };

  return (
    <div>
      <section className="held-up-certificate d-flex flex-column justify-content-between">
        <div style={{ height: "760px" }}></div>

        <div className="d-flex gap-3 ms-4">
          <div style={{ width: "20%", height: "100px" }}>
            <div
              className=""
              style={{
                height: "100%",
                // backgroundColor: "#fff", // optional, keeps the background clean
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden", // ensures no overflow issues
              }}
            >
              <img
                src={
                  user?.image
                    ? `${process.env.REACT_APP_UPLOAD_URL}/users/${user?.image}`
                    : "dummy.jpg"
                }
                alt="patient"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain", // ✅ show full image without cutting
                }}
              />
            </div>
            <p style={{ marginLeft: "35px" }}>{user?.passport_no}</p>
          </div>

          <div className="d-flex flex-column justify-content-between">
            <div>
              <p className="m-0">{settingsData?.website_name}</p>
              {settingsData?.gcc_code && (
                <p className="m-0">G.C.C CODE: {settingsData?.gcc_code}</p>
              )}
            </div>

            <p className="text-center mt-4">
              <span className="fw-bold  fs-5 fst-normal p-0 m-0 ">
                {genderDefineHandler(userDetail?.gender?.name)} is Medically{" "}
                <span
                  className="fw-bold text-uppercase fs-5 fst-normal p-0 m-0 "
                  style={{
                    color: `${
                      user?.status === 1
                        ? "black"
                        : user?.status === 2
                          ? "#5cb85c"
                          : user?.status === 3
                            ? "red"
                            : user?.status === 4 && "#0000FF"
                    }`,
                  }}
                >
                  {user?.status === 1 && ` PROCESSING`}
                  {user?.status === 2 && ` FIT`}
                  {user?.status === 3 && ` UNFIT`}
                  {user?.status === 4 && ` HELD UP`}
                </span>
              </span>
              <span className="ms-3 d-block">For employment in KUWAIT</span>
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
